import I18n from 'lib/i18n'
import React from 'react'

export default function Tabs ({ currentTab, setUserType }) {
  return (
    <div className='link-row'>
      <a
        className={`choser student-link ${currentTab === 'students' ? 'active' : ''}`}
        onClick={() => setUserType('students')}
        style={{ cursor: 'pointer' }}
      >
        <div className='not-responsive-inline-block'>{I18n.t('pages.how1.link_students')}</div>
        <div className='only-responsive-inline-block'>{I18n.t('pages.how1.link_students_small')}</div>
      </a>
      <a
        className={`choser teacher-link ${currentTab === 'teachers' ? 'active' : ''}`}
        onClick={() => setUserType('teachers')}
        style={{ cursor: 'pointer' }}
      >
        <div className='not-responsive-inline-block'>{I18n.t('pages.how1.link_teachers')}</div>
        <div className='only-responsive-inline-block'>{I18n.t('pages.how1.link_teachers_small')}</div>
      </a>
    </div>
  )
}
